import React from "react";
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  Tooltip,
  ResponsiveContainer,
  CartesianGrid,
} from "recharts";
import { formatINRShort } from "../../utils/crmDealValue";

const CrmForecastPanel = ({ forecast }) => {
  if (!forecast) return null;

  const { weightedTotal, rawTotal, byStage, winProbability } = forecast;
  const chartData = (byStage || []).filter((row) => row.weighted > 0);

  return (
    <div className="crm-forecast">
      <div className="crm-forecast__kpis">
        <div className="crm-forecast__kpi">
          <span className="crm-forecast__kpi-label">Weighted forecast</span>
          <strong>{formatINRShort(weightedTotal) || "₹0"}</strong>
          <span className="crm-forecast__kpi-sub">
            {winProbability != null ? `${winProbability}% avg win rate applied` : "Stage probabilities applied"}
          </span>
        </div>
        <div className="crm-forecast__kpi">
          <span className="crm-forecast__kpi-label">Raw pipeline</span>
          <strong>{formatINRShort(rawTotal) || "₹0"}</strong>
          <span className="crm-forecast__kpi-sub">Unweighted open deal value</span>
        </div>
      </div>

      {chartData.length > 0 && (
        <ResponsiveContainer width="100%" height={260}>
          <BarChart data={chartData} margin={{ top: 8, right: 8, left: 0, bottom: 40 }}>
            <CartesianGrid strokeDasharray="3 3" vertical={false} />
            <XAxis dataKey="stage" angle={-25} textAnchor="end" interval={0} height={50} tick={{ fontSize: 11 }} />
            <YAxis tickFormatter={(v) => formatINRShort(v)} tick={{ fontSize: 10 }} width={56} />
            <Tooltip formatter={(v) => formatINRShort(v)} />
            <Bar dataKey="raw" fill="#93c5fd" name="Raw value" radius={[4, 4, 0, 0]} />
            <Bar dataKey="weighted" fill="#2563eb" name="Weighted forecast" radius={[4, 4, 0, 0]} />
          </BarChart>
        </ResponsiveContainer>
      )}
    </div>
  );
};

export default CrmForecastPanel;
